import React from 'react';
import classNames from 'classnames';

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  fullScreen?: boolean;
  centeredToParent?: boolean;
}

const Loading: React.FC<LoadingProps> = ({
  size = 'md',
  color = '#4F46E5',
  className,
  style,
  fullScreen = false,
  centeredToParent = false,
}) => {
  const sizeMap = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-4',
    lg: 'h-12 w-12 border-4',
  };

  const spinnerSize = sizeMap[size];

  const containerClasses = classNames(
    'flex items-center justify-center',
    centeredToParent
      ? 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
      : 'fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
    {
      'z-50 bg-white bg-opacity-75 w-full h-full': fullScreen,
      'w-auto h-auto': !fullScreen,
    },
    className,
  );

  return (
    <div className={containerClasses} style={style} data-testid="loading">
      <div
        className={classNames('animate-spin rounded-full', spinnerSize)}
        style={{
          borderColor: `${color}40`,
          borderTopColor: color,
        }}
      />
    </div>
  );
};

export default Loading;
